import { UlmClientType, ClientConfiguration } from "@custom-types/ulm-types";
import { MainRoutes } from "@router/route-params";
import { runtimeConfig } from "@src/runtime-config";

/** Max height in pixels for screens to be considered small */
export const MAX_HEIGHT_SMALL_SCREEN = "800px";

/** List of all available ULM clients */
export const ULM_CLIENTS: { [key in UlmClientType]: key } = {
  /** Default client */
  default: "default",

  /** FARO Sphere Dashboard */
  sphereDashboard: "sphereDashboard",

  /** FARO Connect (GeoSlam) */
  connect: "connect",

  /** Orbis customers using Stream */
  streamOrbis: "streamOrbis",

  /** Focus customers using Stream */
  streamFocus: "streamFocus",

  /** Sphere Viewer */
  sphereViewer: "sphereViewer",

  /** FARO Scene */
  scene: "scene",

  /** JobWalk XG */
  jwaxg: "jwaxg",

  /** HoloBuilder WebEditor */
  webEditor: "webEditor",

  /** HB-Explorer */
  hbExplorer: "hbExplorer",

  /** JobWalk App HB (Legacy) */
  jwahb: "jwahb",
};

/** Identifier for the email/password authentication option */
export const EMAIL_PROVIDER = "email";

/** Configuration for each client */
export const CLIENT_CONFIGURATION: Record<UlmClientType, ClientConfiguration> =
  {
    default: {
      isEmbedded: false,
      shouldCheckLogin: false,
      isSalesForceTrial:
        runtimeConfig.environment === "production" ? true : false,
      trialType: "cloud-processing-gated-trial",
    },
    sphereDashboard: {
      isEmbedded: true,
      shouldCheckLogin: false,
      isSalesForceTrial:
        runtimeConfig.environment === "production" ? true : false,
      trialType: "cloud-processing-gated-trial",
    },
    connect: {
      isEmbedded: false,
      shouldCheckLogin: false,
      isSalesForceTrial: false,
      trialType: "cloud-processing-faro-connect",
      // Connect app has a custom login redirect URL in within the ULM
      redirectUrlCom: `${runtimeConfig.urls.sphereEntryPageComUrl}/${MainRoutes.connectLoginRedirect}`,
      redirectUrlEu: `${runtimeConfig.urls.sphereEntryPageEuUrl}/${MainRoutes.connectLoginRedirect}`,
    },
    streamOrbis: {
      isEmbedded: false,
      shouldCheckLogin: false,
      isSalesForceTrial:
        runtimeConfig.environment === "production" ? true : false,
      trialType: "cloud-processing-gated-trial",
    },
    streamFocus: {
      isEmbedded: false,
      shouldCheckLogin: false,
      isSalesForceTrial: false,
      trialType: "cloud-processing-gated-trial",
    },
    sphereViewer: {
      isEmbedded: true,
      shouldCheckLogin: false,
      isSalesForceTrial:
        runtimeConfig.environment === "production" ? true : false,
      trialType: "cloud-processing-gated-trial",
    },
    scene: {
      isEmbedded: false,
      shouldCheckLogin: false,
      isSalesForceTrial: false,
      trialType: "cloud-processing-gated-trial",
    },
    jwaxg: {
      isEmbedded: false,
      shouldCheckLogin: false,
      isSalesForceTrial:
        runtimeConfig.environment === "production" ? true : false,
      trialType: "cloud-processing-gated-trial",
    },
    webEditor: {
      isEmbedded: true,
      shouldCheckLogin: false,
      isSalesForceTrial:
        runtimeConfig.environment === "production" ? true : false,
      trialType: "cloud-processing-gated-trial",
    },
    hbExplorer: {
      isEmbedded: false,
      shouldCheckLogin: true,
      isSalesForceTrial: false,
      trialType: "cloud-processing-gated-trial",
    },
    jwahb: {
      isEmbedded: false,
      shouldCheckLogin: false,
      isSalesForceTrial:
        runtimeConfig.environment === "production" ? true : false,
      trialType: "cloud-processing-gated-trial",
    },
  };
